export const sortOptions = [
  { value: "priceLow", label: "Price (lowest first)" },
  { value: "priceHigh", label: "Price (highest first)" },
  // {
  //   value: "bestReviewedAndLowestPrice",
  //   label: "Best reviewed & Lowest price",
  // },
  { value: "starRatingHighest", label: "Star rating (highest first)" },
  { value: "starRatingLowest", label: "Star rating (lowest first)" },
  // { value: "topReviewed", label: "Top reviewed" },
  { value: "topReviewed", label: "Top AI rated" },
  // { value: "promotions", label: "Promotions" },
  {
    value: "bidRequests",
    label: "Bid requests ( comming soon )",
    isDisabled: true,
  },
];
